<template>
  <div class="q-ml-md">
    <div class="row">
      <div class="row col-12">
        <div>
          <p
            class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo"
          >
            Relatório de Vínculos Requisição
            <ModalVinculosRequisicao
              @filtrar="getRelatorioVinculosRequisicao"
              :loadingValue="loadingValue"
            />
          </p>
        </div>
      </div>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :exportName="'Relatorio_Vinculos_Requisicao'"
      :filtros="filtros"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      :salvarType="'relatoriovinculosrequisicao'"
      @flexmonsterLoading="loadingStop"
      @enviarRespostaEp="getRelatorioSalvo"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";

import ModalVinculosRequisicao from "../components/ModalVinculosRequisicao.vue";
import Flexmonster from "../../relatorios/components/Flexmonster.vue";
import { useRoute } from "vue-router";

export default {
  components: { Flexmonster, ModalVinculosRequisicao },
  setup() {
    const store = useStore();
    const route = useRoute();

    const slice = ref({
      columns: "",
      rows: "",
      reportFilters: "",
      measures: "",
    });
    const link = ref("");
    const id = route.params.id;
    const layout = ref("flat");
    const loadingValue = ref("");
    const types = ref([]);
    const updateLink = ref(0);
    const exibir = ref(false);
    const filtros = ref("");
    const showTotals = ref("");
    const formats = ref([
      {
        name: "",
        thousandsSeparator: "",
      },
    ]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});
    const showGrandTotals = ref("");
    const relatorioLink = localStorage.getItem("relatorioLink");

    const getRelatorioVinculosRequisicao = async (
      filtrosFormatados,
      filtrosOriginais
    ) => {
      try {
        let filtrosObject = {
          unidades:
            filtrosOriginais.unidades
              ?.map((id) => {
                const unidade = store.state.org.listaUnidades?.find(
                  (u) => u.id === id
                );
                return unidade?.nome || id;
              })
              .join(", ") || "Todas",
          numeroContrato: filtrosOriginais.numeroContrato || "",
          dataInicial: filtrosOriginais.dataInicial || "",
          dataFinal: filtrosOriginais.dataFinal || "",
          centroCusto: filtrosOriginais.centroCusto || "",
          produto: filtrosOriginais.produto || "",
          gruposProduto:
            filtrosOriginais.gruposProduto?.length > 0 ? "Selecionados" : "",
          categoriasProduto:
            filtrosOriginais.categoriasProduto?.length > 0
              ? "Selecionadas"
              : "",
          tipoFornecimento:
            filtrosOriginais.tipoFornecimento?.length > 0 ? "Selecionados" : "",
          status: filtrosOriginais.status
            ? filtrosOriginais.status === "active"
              ? "Ativo"
              : filtrosOriginais.status === "inactive"
              ? "Inativo"
              : filtrosOriginais.status === "finished"
              ? "Encerrado"
              : filtrosOriginais.status === "canceled"
              ? "Cancelado"
              : filtrosOriginais.status
            : "Todos",
          requisicaoId: filtrosOriginais.requisicaoId || "",
        };

        loadingValue.value = true;
        const response = await store.dispatch(
          "gdcStore/getRelatorioVinculosRequisicao",
          filtrosFormatados
        );

        link.value = response.data.result.url;
        updateLink.value++;
        loadingValue.value = false;
        filtros.value = JSON.stringify(filtrosObject);
        exibir.value = true;
        url.value = response?.request?.responseURL;
      } catch (error) {
        console.log(error);
        loadingValue.value = false;
      }
    };

    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        try {
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });

          const dadosResposta =
            response.data.resultado?.dados || response.data.result?.dados;

          if (!dadosResposta || dadosResposta.length === 0) {
            console.error("Nenhum dado encontrado no relatório salvo");
            return;
          }

          let value = dadosResposta.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          dados.value = value[0];
          urlEp.value = dados.value.url;
          url.value = dados.value.url;
          gerarCsv.value = true;
        } catch (error) {
          console.log("Erro ao carregar relatório salvo:", error);
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        const response = await store.dispatch("rel/getCarregado", {
          url: dados.value.url.replace(
            /(?<=\/\/)[^.]+/,
            store.state.autenticacao.cliente[0]
          ),
        });

        link.value = response.data.return.url;
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;

        return;
      }

      if (
        id == "carregadoLink" &&
        relatorioLink != null &&
        relatorioLink != undefined
      ) {
        exibir.value = true;
        link.value = relatorioLink;
        updateLink.value++;
        url.value = relatorioLink;
        return;
      }
    };

    const getRelatorioSalvo = async (response) => {
      try {
        loadingValue.value = true;

        filtros.value = dados.value.filtros;
        layout.value = dados.value.template.layout;
        showTotals.value = dados.value.template.showTotals;
        showGrandTotals.value = dados.value.template?.showGrandTotals;

        if (response?.result?.url) {
          link.value = response.result.url;
        } else if (response?.return?.url) {
          link.value = response.return.url;
        } else if (response?.resultado?.dados) {
          link.value = response.resultado.dados;
        } else if (response?.data?.result?.url) {
          link.value = response.data.result.url;
        } else if (response?.data?.return?.url) {
          link.value = response.data.return.url;
        } else if (typeof response === "string") {
          link.value = response;
        } else {
          console.error(response);
          loadingValue.value = false;
          return;
        }

        slice.value.columns = dados.value.template.columns;
        slice.value.rows = dados.value.template.rows;
        slice.value.reportFilters = dados.value.template.filtros;
        slice.value.measures = dados.value.template.values;
        exibir.value = true;

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        updateLink.value++;
        loadingValue.value = false;
      } catch (error) {
        console.error(error);
        loadingValue.value = false;
      }
    };

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    onMounted(() => {
      verificarUrl();
    });

    return {
      getRelatorioVinculosRequisicao,
      slice,
      layout,
      types,
      link,
      updateLink,
      loadingValue,
      exibir,
      id,
      getRelatorioSalvo,
      filtros,
      showTotals,
      url,
      urlEp,
      gerarCsv,
      dados,
      formats,
      loadingStop,
      verificarUrl,
      showGrandTotals,
    };
  },
};
</script>
